(function () {
  'use strict';

  angular.module('settings.api').controller('settingsApiCtrl', settingsApiCtrl);

  settingsApiCtrl.$inject = ['SettingsApi', '$mdDialog', '$translate'];

  function settingsApiCtrl(
    SettingsApi,
    /** @type {angular.material.IDialogService} */ $mdDialog,
    $translate,
  ) {
    var vm = this;
    vm.updateApiKey = getApiKey;
    vm.apiKey = '';
    vm.hideKey = true;

    getApiKey();

    function getApiKey(update) {
      var data = {};
      var requireConfirm = false;
      if (typeof update != 'undefined') {
        data = { update: 1 };
        requireConfirm = true;
      }
      if (requireConfirm) {
        $mdDialog
          .show(
            $mdDialog
              .confirm()
              .title($translate.instant('settings.api.confirm.title'))
              .textContent($translate.instant('settings.api.confirm.content'))
              .ariaLabel('Alert Dialog')
              .ok($translate.instant('settings.api.confirm.ok'))
              .cancel($translate.instant('general.cancel.long')),
          )
          .then(
            function () {
              SettingsApi.getApiKey(data, function (response) {
                vm.apiKey = response.apiKey;
              });
            },
            function () {},
          );
      } else {
        SettingsApi.getApiKey(data, function (response) {
          vm.apiKey = response.apiKey;
        });
      }
    }
  }
})();
